import type { MouseEvent } from 'react';
import { FleetChip } from '@entities/fleet';
import { KeyButton, Table, TableBox } from './styles';
import { DICT_UI, statusLabel, type ColumnContext, type DictRecord, type TableDict } from './types';

/**
 * Записи справочника: колонки по смыслу справочника (у лицензии — номер,
 * месторождение, лимит, срок), состояние — плашкой. Строка открывает запись
 * в боковой панели; ключ записи — кнопка, чтобы открыть и с клавиатуры.
 */
export function DictTable({
  dict,
  rows,
  ctx,
  onOpen,
}: {
  dict: TableDict;
  rows: readonly DictRecord[];
  ctx: ColumnContext;
  onOpen: (rec: DictRecord) => void;
}) {
  const ui = DICT_UI[dict];
  // Щелчок по строке, но не по выделенному тексту — его копируют.
  const onRow = (rec: DictRecord) => (e: MouseEvent<HTMLTableRowElement>) => {
    if (e.target instanceof HTMLElement && e.target.closest('button')) return;
    if (window.getSelection()?.toString()) return;
    onOpen(rec);
  };

  return (
    <TableBox>
      <Table>
        <thead>
          <tr>
            {ui.columns.map((c) => (
              <th key={c.key} scope="col" className={c.num ? 'num' : undefined}>
                {c.title}
              </th>
            ))}
            <th scope="col">Состояние</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((rec) => {
            const active = rec.is_active === true;
            return (
              <tr
                key={String(rec.id)}
                data-open="true"
                data-inactive={active ? undefined : 'true'}
                onClick={onRow(rec)}
              >
                {ui.columns.map((c) => {
                  const sub = c.sub?.(rec, ctx);
                  return (
                    <td key={c.key} className={c.num ? 'num' : undefined}>
                      {c.primary ? (
                        <KeyButton type="button" onClick={() => onOpen(rec)}>
                          {c.cell(rec, ctx)}
                        </KeyButton>
                      ) : (
                        c.cell(rec, ctx)
                      )}
                      {sub && <div className="sub">{sub}</div>}
                    </td>
                  );
                })}
                <td className="status">
                  <FleetChip $tone={active ? 'success' : 'muted'}>
                    {statusLabel(dict, active)}
                  </FleetChip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </TableBox>
  );
}
